import get from 'lodash/get';
import React from 'react';
import styled, { css } from 'styled-components';
import FallbackImage from './FallbackImage.svg';

const DoctorImage = ({ altText, imageSource = FallbackImage, lazy = true }) => {
    return (
        <NativeLazyLoadableImage
            alt={altText}
            data-test={`doctor-card-photo-img`}
            itemProp="image"
            lazy={lazy && !global.screenshot}
            src={imageSource}
        />
    );
};

const getSizeFromTheme = (theme) => get(theme, 'photo.size', '44px');

const sizeStyles = (props) => css`
    width: ${getSizeFromTheme(props.theme)};
    height: ${getSizeFromTheme(props.theme)};
`;

const NativeLazyLoadableImage = styled.img.attrs((props) =>
    props.lazy ? { loading: 'lazy' } : {}
)`
    ${sizeStyles};
    display: inline-block;
    overflow: hidden;
`;

export {
    DoctorImage,
    DoctorImage as default,
    NativeLazyLoadableImage,
    getSizeFromTheme,
    sizeStyles,
};
